/* ===========================================================
   MB Cleanings — Producten page interactions
   - GYEON kortingscode kopiëren
   - Variant switching + price update + cart add (AJAX)
   =========================================================== */

function copyCode() {
    navigator.clipboard.writeText('MBCLEANINGS').then(() => {
        const btn = document.getElementById('copyBtn');
        btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg> Gekopieerd!';
        btn.classList.add('copied');
        setTimeout(() => {
            btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg> Kopieer code';
            btn.classList.remove('copied');
        }, 2000);
    });
}

/* ----------- Linked Shopify product: variants + cart ----------- */
(() => {
    const form = document.getElementById('mbc-product-form');
    if (!form) return;

    const variantsScript = document.querySelector('[data-mbc-variants]');
    if (!variantsScript) return;

    let variants = [];
    try { variants = JSON.parse(variantsScript.textContent.trim()); }
    catch (e) { console.warn('[MBC] Variant data parse error', e); return; }

    const variantInput = form.querySelector('[data-mbc-variant-id]');
    const priceCurrent = document.querySelector('[data-mbc-price-current]');
    const priceCompare = document.querySelector('[data-mbc-price-compare]');
    const priceWrap = document.querySelector('[data-mbc-price]');
    const btn = form.querySelector('[data-mbc-cart-btn]');
    const btnText = form.querySelector('[data-mbc-cart-btn-text]');
    const selects = form.querySelectorAll('.variant-select');
    const productImage = document.querySelector('.product-image img, .product-image-top img');

    function findActiveVariant() {
        const selected = [];
        selects.forEach((s) => selected.push(s.value));
        if (selected.length === 0) return variants[0];
        return variants.find((v) =>
            v.options.length === selected.length &&
            v.options.every((opt, i) => opt === selected[i])
        ) || null;
    }

    function applyVariant(variant) {
        if (!variant) {
            btn.disabled = true;
            btnText.textContent = 'Niet beschikbaar';
            btn.classList.add('product-btn--disabled');
            return;
        }
        if (variantInput) variantInput.value = variant.id;
        if (priceCurrent) priceCurrent.textContent = variant.price;
        if (priceWrap) {
            const existingCompare = priceWrap.querySelector('.price-was');
            if (variant.compare_at_price) {
                if (existingCompare) {
                    existingCompare.textContent = variant.compare_at_price;
                } else {
                    const span = document.createElement('span');
                    span.className = 'price-was';
                    span.dataset.mbcPriceCompare = '';
                    span.textContent = variant.compare_at_price;
                    priceWrap.insertBefore(span, priceWrap.firstChild);
                }
            } else if (existingCompare) {
                existingCompare.remove();
            }
        }
        btn.disabled = !variant.available;
        btn.classList.toggle('product-btn--disabled', !variant.available);
        btnText.textContent = variant.available ? 'In winkelmandje' : 'Uitverkocht';
        if (variant.featured_image && productImage) {
            productImage.src = variant.featured_image;
        }
    }

    selects.forEach((s) => {
        s.addEventListener('change', () => applyVariant(findActiveVariant()));
    });

    /* Initial render — make sure UI is correct on first paint */
    applyVariant(findActiveVariant());

    /* AJAX add-to-cart with confirmation toast */
    form.addEventListener('submit', (e) => {
        e.preventDefault();
        if (btn.disabled) return;

        const formData = new FormData(form);
        btn.classList.add('product-btn--loading');
        btnText.textContent = 'Toevoegen…';

        fetch('/cart/add.js', {
            method: 'POST',
            headers: { Accept: 'application/javascript' },
            body: formData,
        })
            .then((r) => r.json())
            .then((data) => {
                btn.classList.remove('product-btn--loading');
                if (data.status && data.status >= 400) {
                    btnText.textContent = 'Probeer opnieuw';
                    showToast(data.description || 'Er ging iets mis', true);
                    setTimeout(() => (btnText.textContent = 'In winkelmandje'), 2500);
                    return;
                }
                btnText.textContent = 'Toegevoegd ✓';
                showToast('Toegevoegd aan winkelmandje', false);
                /* Update cart count if your nav has one */
                fetch('/cart.js').then((r) => r.json()).then((cart) => {
                    document.querySelectorAll('[data-cart-count]').forEach((el) => {
                        el.textContent = cart.item_count;
                    });
                });
                setTimeout(() => (btnText.textContent = 'In winkelmandje'), 2500);
            })
            .catch(() => {
                btn.classList.remove('product-btn--loading');
                btnText.textContent = 'In winkelmandje';
                /* Fallback: traditional submit redirects to /cart */
                form.removeEventListener('submit', () => {});
                form.submit();
            });
    });

    function showToast(message, isError) {
        let toast = document.getElementById('mbc-toast');
        if (!toast) {
            toast = document.createElement('div');
            toast.id = 'mbc-toast';
            toast.className = 'mbc-toast';
            document.body.appendChild(toast);
        }
        toast.textContent = message;
        toast.classList.toggle('mbc-toast--error', !!isError);
        toast.classList.add('is-visible');
        clearTimeout(toast._t);
        toast._t = setTimeout(() => toast.classList.remove('is-visible'), 2800);
    }
})();

/* ----------- Product detail page: gallery thumb switching ----------- */
(() => {
    const main = document.querySelector('[data-mbc-gallery-main]');
    const activeImg = document.querySelector('[data-mbc-gallery-active]');
    const thumbs = document.querySelectorAll('[data-mbc-gallery-thumb]');
    if (!main || !activeImg || thumbs.length === 0) return;

    thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => {
            const src = thumb.dataset.img;
            if (!src) return;
            activeImg.src = src;
            thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
        });
    });
})();


